import { Grid2Props, Grid2 as Grid } from "@mui/material";
import React from "react";
import { singleGridItem } from "../../fields/defaultStyles";
import FormTextField from "../../fields/basic/TextField";
import FormSelectField from "../../fields/basic/SelectField";
import useEvidenceLogic from "../../../../hooks/logic/evidenceLogic";

const NameExternalEvidence: React.FC<Grid2Props> = (props) => {
  const { externalEvidenceTypeEnum } = useEvidenceLogic();
  return (
    <Grid container spacing={2} {...singleGridItem} {...props}>
      <FormTextField
        name="attribute_pre"
        label="Name Attribute Pre"
        placeholder="Enter name attribute pre"
      />
      <FormTextField name="name" label="Name" placeholder="Enter name" />
      <FormTextField
        name="attribute_post"
        label="Name Attribute Post"
        placeholder="Enter name attribute post"
      />
      <FormSelectField
        name="external_evidence_type"
        label="Evidence Type"
        placeholder="Select evidence type"
        useEnum={externalEvidenceTypeEnum}
      />
    </Grid>
  );
};

export default NameExternalEvidence;
